import { QueryClient } from "@tanstack/react-query";

interface ViteEnv {
  DEV?: boolean;
}

function isDevMode(): boolean {
  const meta = import.meta as { env?: ViteEnv };
  return meta.env?.DEV ?? false;
}

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 2,
      refetchOnWindowFocus: isDevMode(),
    },
  },
});
